var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M46.15 86.4H4.77A4.77 4.77 0 0 1 0 81.631V4.77A4.77 4.77 0 0 1 4.769 0h76.863A4.77 4.77 0 0 1 86.4 4.769V81.63a4.77 4.77 0 0 1-4.768 4.769H59.615V52.94h11.23l1.682-13.04H59.615v-8.325c0-3.775 1.048-6.348 6.462-6.348l6.905-.003V13.563c-1.194-.16-5.293-.514-10.062-.514-9.955 0-16.77 6.077-16.77 17.236v9.616H34.9v13.04h11.26V86.4z","transform":"matrix(.987688 -.156434 .156434 .987688 -.139519 12.921366)","fill":"#5e5e5e","fillRule":"evenodd"}));
}

Facebook.defaultProps = {"width":"98","height":"98"};

module.exports = Facebook;

Facebook.default = Facebook;
